import { ORCHESTRATION_SERVICE_ERROR_CODES } from '../../../constants/index';
import { Box, Grid } from '@mui/material';
import { Warning, Square } from '@mui/icons-material';
import { Typography } from '@uhc-tempo/components';

const gacOrPacDisclaimerText =
    'You are seeing an average cost for this procedure because specific provider costs are not available or there are not affiliated providers. Check with your provider and health plan for details to confirm the costs that you may be charged for a service or procedure.';

export default function PacGacDisclaimer(props) {
    const {
        claimHasNoGACPACRatesAvailable,
        claimHasNoCostShare,
        NoGACPACRatesErrorText,
        dontShowAverageCostText,
    } = props;

    const noRatesNorCostShare = claimHasNoGACPACRatesAvailable || claimHasNoCostShare;

    const getDisclaimerText = () => {
        let text = null;
        if (claimHasNoCostShare || !claimHasNoGACPACRatesAvailable) {
            if (noRatesNorCostShare) {
                /* Although we will get the same message in both the cases,
                we have this condition because NoGACPACRatesErrorText will only be initialized
                when there are no GAC or PAC rates, but we want this message even when
                there are no costShare for the estimate */
                text = claimHasNoCostShare
                    ? ORCHESTRATION_SERVICE_ERROR_CODES.NO_GAC_OR_PAC_RATES.displayMessage
                    : NoGACPACRatesErrorText;
            } else if (!dontShowAverageCostText) {
                text = gacOrPacDisclaimerText;
            }
        }
        return text;
    };

    const disclaimerText = getDisclaimerText();

    if (disclaimerText) {
        return (
            <Box
                component="div"
                px={3}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    bgcolor: '#FEF9EA',
                    minHeight: '96px',
                    marginBottom: '12px',
                }}
                data-testid="gacOrPacDisclaimer"
            >
                <Box>
                    <div key={`gac-or-pac-disclaimer-div`}>
                        <Grid
                            container
                            spacing={1}
                            display="flex"
                            direction="row"
                            justifyContent="space-between"
                            alignItems="start"
                            py={1}
                            wrap="nowrap"
                            sx={{
                                paddingTop: '14px',
                            }}
                        >
                            <Grid item sx={{ position: 'relative' }}>
                                <Square
                                    style={{
                                        color: '#19191A',
                                    }}
                                    sx={{
                                        position: 'absolute',
                                        height: '12px',
                                        width: '30px',
                                        left: '5px',
                                        top: '16.5px',
                                    }}
                                />
                                <Warning
                                    sx={{
                                        position: 'sticky',
                                        zIndex: '1',
                                    }}
                                    style={{
                                        color: '#F5B700',
                                    }}
                                />{' '}
                            </Grid>
                            <Grid item>
                                <Typography.Paragraph
                                    data-testid={noRatesNorCostShare ? 'no-gac-pac-rates' : ''}
                                    style={{
                                        fontFamily: '"UHC Sans", Arial, sans-serif',
                                        fontStyle: 'Normal',
                                        fontSize: '16px',
                                        lineHeight: '22px',
                                        color: '#333333',
                                    }}
                                >
                                    {!noRatesNorCostShare && (
                                        <span style={{ fontWeight: 700 }}>{`Average Cost: `}</span>
                                    )}
                                    {disclaimerText}{' '}
                                </Typography.Paragraph>
                            </Grid>
                        </Grid>
                    </div>
                </Box>
            </Box>
        );
    } else {
        return null;
    }
}
